import {AfterViewInit, Component, HostListener, ViewChild} from '@angular/core';
import {LoginService} from './services/login.service';
import {PickupService} from './services/pickup.service';
import {Router} from '@angular/router';
import {MatDrawer} from '@angular/material/sidenav';
import {UtilitiesService} from './services/utilities.service';
import {QueueService} from './services/queue.service';
import packagejson from '../../package.json';
import {SocketService} from './services/socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'runnerApp';
  showFiller = false;
  public appVersion: string = packagejson.version;
  showingPopup = false;
  popupText = '';

  @ViewChild('drawer') drawer !: MatDrawer;
  protected readonly close = close;

  constructor(public pickupService: PickupService, private utilitiesService: UtilitiesService, private socketService: SocketService,
              public loginService: LoginService, private queueService: QueueService, private router: Router, private provService: PickupService) {
    this.utilitiesService.drawerControllerEmitter$.subscribe((event: boolean) => {
      this.changeDrawerState(event);
    });
    this.queueService.queueHandler();
  }

  @HostListener('document:touchstart', ['$event']) onUserTouch(event: any) {
    console.log('User touch the screen');
    this.socketService.updateSilenceMode();
  }

  ngAfterViewInit() {
    this.utilitiesService.getObject('usuario').then((usuario: any) => {

      let usr = JSON.parse(usuario);
      if (usr.id) {
        this.pickupService.usuario = usr;

        this.pickupService.local = usr.id_tienda;

        this.pickupService.usuario.nombre_usuario = usr.nombre_usuario;

        this.loginService.logeado = true;

        if (this.provService.usuario.codigo_local !== 0) this.socketService.conectarSocket();

        if (window.location.href.includes('recepcion-bt')) {
          this.router.navigate(['/recepcion-bt']);
        } else {
          this.router.navigate(['/inicio']);
        }
      }
    });

    this.provService.silenceSource$.subscribe((silenceMode: string) => {
      console.log('Silence mode: ', silenceMode);
      this.showingPopup = true;
      switch (silenceMode) {
        case 'cliente_en_camino':
          this.popupText = 'Nuevo cliente en camino';
          break;
        case 'llegada_cliente':
          this.popupText = 'Nuevo cliente en la tienda';
          break;
      }
    });

    try {
      navigator.permissions.query({name: 'camera' as PermissionName}).then(async (result) => {
        if (result.state === 'granted') {
          console.log('Permiso concedido');
          this.cacheUsableCameras();
        } else if (result.state === 'prompt') {
          console.log('El usuario aún no ha otorgado permisos');
          await navigator.mediaDevices.getUserMedia({
            video: true,
          });
          this.cacheUsableCameras();
        } else {
          console.log('Permiso denegado');
        }
      });

    } catch (err) {
      console.error('Error al acceder a la cámara:', err);
      return;
    }

  }

  cacheUsableCameras() : void{
    if(!this.pickupService.cachedCameras || !this.pickupService.cachedCameras.length){
      navigator.mediaDevices.enumerateDevices().then((devices: MediaDeviceInfo[]) => {
        const videoDevices = devices.filter(device => device.kind === 'videoinput');

        const devicesId = videoDevices.map((device: MediaDeviceInfo) => device.deviceId);
        this.pickupService.cachedCameras = devicesId;
      });
    }
  }

  closePopup() {
    this.showingPopup = false;
  }

  changeDrawerState(event: boolean) {
    if (event) this.drawer.open();
    else this.drawer.close();
  }

  detenerSonido() {
    console.log('detener sonido');
    this.pickupService.detenerSonido();
  }
}
